import {
    triggerSignupMutation,
    triggerSignupDefault
} from "./components/save-for-later-button/trigger-sign-up-SFLB";

export const defaults = {
    ...triggerSignupDefault
};

export const Mutation = {
    ...triggerSignupMutation
};
